import { render, staticRenderFns } from "./ClientSuplier.vue?vue&type=template&id=219cc88a&scoped=true"
import script from "./ClientSuplier.vue?vue&type=script&lang=js"
export * from "./ClientSuplier.vue?vue&type=script&lang=js"
import style0 from "./ClientSuplier.vue?vue&type=style&index=0&id=219cc88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219cc88a",
  null
  
)

export default component.exports